import React from "react";
import { Button, StyledText } from "../../../../components/common";
import styled from "styled-components";
import useMashupNWinHome from "../hooks/useMashupnWinHome";
import { useHistory } from "react-router-dom";
import { RightArrow } from "../../../../components/svgs";

const MashupNowButton = ({
  bgcolor,
  label,
  textColor,
  width,
  showLeaderboard = false,
  leaderboardUrl,
}) => {
  const { background } = useMashupNWinHome();
  const history = useHistory();

  const mashupLink = "https://mymtn.mtn.com.gh/cB5t/hi5wvc9t?page=mashup";
  const goToLeaderboard = () => {
    history.push(leaderboardUrl ? leaderboardUrl : "#");
  };

  return (
    <ButtonContainer>
      {/* <Button
        style={{
          width: width ? width : "80%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        color={bgcolor ? bgcolor : background}
        onClick={() => {
          window.open(mashupLink, "mashup");
        }}
      >
        <StyledText
          style={{ marginRight: 10 }}
          color={textColor ? textColor : "white"}
        >
          {label ? label : "Mashup Now"}
        </StyledText>
      </Button> */}

      {/* Optional Leaderboard Button */}
      {showLeaderboard && (
        <Button
          style={{
            width: width ? width : "80%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
            border: "2px solid #333",
            position: "relative",
          }}
          color="white"
          onClick={goToLeaderboard}
          disabled={!leaderboardUrl}
        >
          <StyledText style={{ marginRight: "10px" }} color="#333">
            Leaderboard
          </StyledText>
          <div style={{ position: "absolute", right: "20px" }}>
            <RightArrow />
          </div>
        </Button>
      )}
    </ButtonContainer>
  );
};

export default MashupNowButton;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 32px;
`;
